import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import LoadingWrapper from '../../../sharedModules/layout/LoadingWrapper';

import axios from '../../../sharedModules/utils/axios.utils';
import { CertificateSubmission } from '../../model';

interface CreateNewSubmissionCardProps {
  customerId?: string;
  defaultProjectName?: string;
}

const CreateNewSubmissionCard: React.FC<CreateNewSubmissionCardProps> = (props) => {
  const history = useHistory();

  const { customerId, defaultProjectName } = props;

  let [errorMessage, setErrorMessage] = useState<string>('');
  let [formValues, setFormValues] = useState<CertificateSubmission>();
  let [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    let updatedValues = { ...formValues };
    updatedValues.submission_name = defaultProjectName;
    updatedValues.customer_id = customerId;

    setFormValues(updatedValues);
  }, [defaultProjectName]);

  const handleCreateNewSubmission = async () => {
    setLoading(true);
    try {
      const response: any = await axios.post('/energy_solutions/certificate_submissions', {
        certificate_submission: formValues,
      });
      history.push(`/energy_solutions/submissions/${response.data.id}`);
      setErrorMessage('');
    } catch (error) {
      setErrorMessage('Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <LoadingWrapper isLoading={loading} message="Loading...">
      <Grid container spacing={2} style={{ padding: '1% 2%' }}>
        <Grid item xs={12} md={12}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Create New Submission
              </Typography>
              <br />
              <Box mb={3}>
                <TextField
                  fullWidth
                  label="Project Name"
                  value={formValues?.submission_name}
                  onChange={(e) => setFormValues({ ...formValues, submission_name: e.target.value })}
                  placeholder="Enter a project name for this submission"
                  variant="outlined"
                  helperText="This name will help you identify this submission later"
                />
              </Box>

              <Box display="flex" gap={2}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleCreateNewSubmission}
                  disabled={loading || !formValues?.submission_name}
                >
                  {loading ? 'Creating...' : 'Create New Submission'}
                </Button>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </LoadingWrapper>
  );
};

export default CreateNewSubmissionCard;
